var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1300_27726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 26.2147C21.6406 26.2147 26.2137 21.6416 26.2137 16.0004C26.2137 10.3592 21.6406 5.78613 15.9994 5.78613C10.3582 5.78613 5.78516 10.3592 5.78516 16.0004C5.78516 21.6416 10.3582 26.2147 15.9994 26.2147Z",
    fill: "#F7ED90",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8145 17.5723C11.6002 20.4008 14.743 22.1294 17.5716 21.3437C19.3002 20.7151 20.7145 19.3008 21.1859 17.5723",
    fill: "#F7ED90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8145 17.5723C11.6002 20.4008 14.743 22.1294 17.5716 21.3437C19.3002 20.7151 20.7145 19.3008 21.1859 17.5723",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5428 13.486C12.3692 13.486 12.2285 13.3453 12.2285 13.1717C12.2285 12.9981 12.3692 12.8574 12.5428 12.8574",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.543 13.486C12.7165 13.486 12.8573 13.3453 12.8573 13.1717C12.8573 12.9981 12.7165 12.8574 12.543 12.8574",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4569 13.486C19.2833 13.486 19.1426 13.3453 19.1426 13.1717C19.1426 12.9981 19.2833 12.8574 19.4569 12.8574",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.457 13.486C19.6306 13.486 19.7713 13.3453 19.7713 13.1717C19.7713 12.9981 19.6306 12.8574 19.457 12.8574",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1300_27726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.523efb4ce4320fee91c6951b9b0a6ddd.svg";
export { ForwardRef as ReactComponent };